import React, { useEffect, useState } from 'react';
import RequestsSearchForm from './RequestsSearchForm';
import RequestsResults from './RequestsResults';
import Header from 'components/Header/Header';
import { useWithTitle } from 'utils/hooks/useWithTitle';
import { TourRequests } from './TourRequests';
import { useActions } from 'utils/hooks/useActions';
import { useStudy } from 'utils/hooks/useStudy';

const RequestsSend: React.FC<any> = () => {
  const { title } = useWithTitle();
  const { storeRequestSearchResults } = useActions();
  const { linkBack } = useStudy();
  const backFromDetail = linkBack();

  const [canLoadResults, setCanLoadResults] = useState<boolean>(!backFromDetail);

  const renderedSteps = () => {
    return <TourRequests type="main" />;
  };

  useEffect(() => {
    if (!backFromDetail) {
      storeRequestSearchResults([]);
    }
    setCanLoadResults(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header title={title} addUrl="/requests/search" TourComponent={renderedSteps()} />
      <RequestsSearchForm />
      {canLoadResults && <RequestsResults />}
    </>
  );
};

export default RequestsSend;
